export const SET_DASHBOARD = 'SET_DASHBOARD';
export const SET_DASHBOARD_CHART = 'SET_DASHBOARD_CHART';
